import React, { useState } from 'react';
import { Modal, Button, Form, InputGroup, Alert, Spinner } from 'react-bootstrap';
import { rechargeTenantWallet } from '../../api/api'; //

const RechargeWalletModal = ({ show, onHide, tenant, onSuccess }) => {
    const [formData, setFormData] = useState({
        credit_amount: '',
        usd_amount: '',
        description: 'Manual Admin Top-up'
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await rechargeTenantWallet({
                tenant_id: tenant.id, //
                credit_amount: parseFloat(formData.credit_amount),
                usd_amount: parseFloat(formData.usd_amount),
                description: formData.description
            });
            onSuccess(); // Refresh dashboard data
        } catch (err) {
            setError(err.response?.data?.detail || 'Failed to recharge wallet');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="bg-success text-white">
                <Modal.Title>Recharge Wallet: {tenant?.name}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {error && <Alert variant="danger" role="alert">{error}</Alert>}
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Credit Amount to Add</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type="number"
                                step="0.0001"
                                required
                                value={formData.credit_amount}
                                onChange={(e) => setFormData({...formData, credit_amount: e.target.value})}
                                placeholder="e.g. 500.00"
                            />
                            <InputGroup.Text>Credits</InputGroup.Text>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Actual USD Paid</Form.Label>
                        <InputGroup>
                            <InputGroup.Text>$</InputGroup.Text>
                            <Form.Control
                                type="number"
                                step="0.01"
                                required
                                value={formData.usd_amount}
                                onChange={(e) => setFormData({...formData, usd_amount: e.target.value})}
                                placeholder="0.00"
                            />
                        </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Internal Reference / Note</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={formData.description}
                            onChange={(e) => setFormData({...formData, description: e.target.value})}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={loading}>
                        Cancel
                    </Button>
                    <Button variant="success" type="submit" disabled={loading}>
                        {loading ? <Spinner size="sm" aria-hidden="true" /> : 'Confirm Recharge'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default RechargeWalletModal;
